/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountButton_viewer = {
    readonly id: string;
    readonly email: string;
    readonly " $refType": "AccountButton_viewer";
};
export type AccountButton_viewer$data = AccountButton_viewer;
export type AccountButton_viewer$key = {
    readonly " $data"?: AccountButton_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountButton_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "AccountButton_viewer",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "email",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '832871872571a5ec6f21fff0968a53fa';
export default node;
